module.exports = __webpack_public_path__ + "img/features4.b8461152.png";